// Базовые CRUD операции обрабатываются через common модуль
// export const GET_ITEMS = 'GET_ITEMS';
// export const GET_ITEM = 'GET_ITEM';
// export const CREATE_ITEM = 'CREATE_ITEM';
// export const UPDATE_ITEM = 'UPDATE_ITEM';
// export const DELETE_ITEM = 'DELETE_ITEM';

// Кастомные действия
export const APP_CREATE_DEFAULT_SECTIONS = 'APP_CREATE_DEFAULT_SECTIONS'; 